export default __webpack_public_path__ + "static/media/pills.6553ddb8.webp";